import { render, staticRenderFns } from "./botoesNavegacao.vue?vue&type=template&id=71ad6d78&scoped=true&"
import script from "./botoesNavegacao.vue?vue&type=script&lang=js&"
export * from "./botoesNavegacao.vue?vue&type=script&lang=js&"
import style0 from "./botoesNavegacao.vue?vue&type=style&index=0&id=71ad6d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad6d78",
  null
  
)

export default component.exports